import store from '@/store';
import { format } from 'date-fns';

interface DateFormatMixinInterface {
  methods: {
    formatDate: (value: string | null, formatTemplate: string) => string | null;
  };
}

export const dateFormatMixin: DateFormatMixinInterface = {
  methods: {
    formatDate(value: string | null, formatTemplate: string): string | null {
      if (!value) return null;
      try {
        return format(new Date(value), formatTemplate);
      } catch (err) {
        return null;
      }
    }
  }
};
